<div *ngIf="showScrollbar()" class="d-flex justify-content-start free-courses px-1 w-100 mb-2 pb-2">
  <div class="card card-skinny w-100 col-8 col-md-2 pt-0 px-0 pb-2 mr-3 ml-0 free-courses-item"
       *ngFor="let course of courses(); index as i">
    <div class="card-header w-100 cursor-pointer" (click)="goToUrl(course)"
         [ngStyle]="{'background-image': 'linear-gradient(to right, rgba(0,0,0,0.1), rgba(0,0,0,0)), url('+ course.thumbnail_url + ')'}">
    </div>
    <div class="w-100">
      <div class="align-items-end">
        <div class="card-actions d-flex w-100 px-2 mt-2"
             *ngIf="!course.purchased"
             [ngClass]="{'justify-content-end': course.previewLink === '', 'justify-content-between': course.previewLink !== ''}">
          <div *ngIf="course.requireRegistrationForPreview && !user()"></div>
          <a *ngIf="!course.requireRegistrationForPreview || (course.requireRegistrationForPreview && !!user())" [href]="course.previewLink" target="_blank" class="btn"
             [ngClass]="{'d-none' : course.previewLink === ''}">Preview</a>
            @if ((course.isLocked && !!user()) || (!course.requireRegistrationForPreview && !user())) {
              @if (course.inCoursePurchaseEnabled && !course.deepLinkToMarketing) {
                <a class="btn btn-round btn-primary" [innerText]="course.buyLinkText || 'Purchase'" (click)="onBuyClick($event, course)"></a>
              } @else if(course.inCoursePurchaseEnabled && course.deepLinkToMarketing){
                <a class="btn btn-round btn-primary" [innerText]="course.previewLink || 'Purchase'" (click)="onBuyClick($event, course)"></a>
              } @else {
                <a class="btn btn-round btn-primary" [href]="course.purchaseLink" target="_blank" [innerText]="course.buyLinkText || 'Purchase'"></a>
              }
            }

          <button *ngIf="course.requireRegistrationForPreview && !user()" class="btn btn-round btn-primary" (click)="openSignupForm($event, course)">{{course.buyLinkText || 'Purchase'}}</button>
        </div>
        <div class="card-actions d-flex w-100 px-2 mt-2"
             *ngIf="course.purchased"
             [ngClass]="{'justify-content-end': course.previewLink === '', 'justify-content-between': course.previewLink !== ''}">
          <a [href]="course.previewLink" target="_blank" class="btn"
             [ngClass]="{'d-none' : course.previewLink === ''}">Launch Course</a>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="!showScrollbar()" class="row d-flex justify-content-start free-courses px-1 w-100 mb-2 pb-2">
  <div [ngClass]="{'fit-content-item': fitContent(), 'col': !fitContent()}" class="px-2 mt-4 free-courses-item"
       *ngFor="let course of courses(); index as i">
    <div class="card card-skinny w-100 p-0 pb-2">
      <div class="card-header w-100 cursor-pointer" (click)="goToUrl(course)"
           [ngStyle]="{'background-image': 'url('+ course.thumbnail_url + ')'}">
      </div>

      <div class="w-100">
        <div class="align-items-end">
          <div class="card-actions d-flex w-100 px-2 mt-2"
               *ngIf="!course.purchased"
               [ngClass]="{'justify-content-end': course.previewLink === '', 'justify-content-between': course.previewLink !== ''}">
            <div *ngIf="course.requireRegistrationForPreview && !user()"></div>
            <a *ngIf="!course.requireRegistrationForPreview || (course.requireRegistrationForPreview && !!user())" [href]="course.previewLink" target="_blank" class="btn"
               [ngClass]="{'d-none' : course.previewLink === ''}">Preview</a>
              @if ((course.isLocked && !!user()) || (!course.requireRegistrationForPreview && !user())) {
                @if (course.inCoursePurchaseEnabled && !course.deepLinkToMarketing) {
                  <a class="btn btn-round btn-primary" [innerText]="course.buyLinkText || 'Purchase'" (click)="onBuyClick($event, course)"></a>
                } @else if (course.inCoursePurchaseEnabled && course.deepLinkToMarketing){
                  <a class="btn btn-round btn-primary" [innerText]="'Purchase'" [href]="course.previewLink"></a>
                } @else {
                  <a class="btn btn-round btn-primary" [href]="course.purchaseLink" target="_blank" [innerText]="course.buyLinkText || 'Purchase'"></a>
                }
              }
            <button *ngIf="course.requireRegistrationForPreview && !user()" class="btn btn-round btn-primary" (click)="openSignupForm($event, course)">{{course.buyLinkText || 'Purchase'}}</button>
          </div>
          <div class="card-actions d-flex w-100 px-2 mt-2 justify-content-end"
               *ngIf="course.purchased">
            <a [href]="course.previewLink" target="_blank" class="btn"
               [ngClass]="{'d-none' : course.previewLink === ''}">Launch Course</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
